import React from 'react';
import Header from '../../components/Header/Header';
import Hero from '../../components/Hero/Hero';
import WaveDivider from '../../components/WaveDivider/WaveDivider';
import About from '../../components/About/About';
import ShopCollections from '../../components/ShopCollections/ShopCollections';
import Creations from '../../components/Creations/Creations';
import ImageCollection from '../../components/ImageCollection/ImageCollection';
import FeaturedShowcase from '../../components/FeaturedShowcase/FeaturedShowcase';
import Footer from '../../components/Footer/Footer';

function Home(): React.ReactElement {
  return (
    <div className="app">
      <Header />
      <main>
        <Hero />
        <About />
        <ShopCollections />
        <WaveDivider fill="var(--cream-bg)" variant="scoopUp" />
        <Creations />
        <ImageCollection />
        <WaveDivider fill="var(--cream-bg)" variant="multiWave" />
        <FeaturedShowcase />
        <div className="footer-wrapper">
          <WaveDivider fill="#3d2c29" variant="gentleWave" flush />
          <Footer />
        </div>
      </main>
    </div>
  );
}

export default Home;
